module.exports = __webpack_public_path__ + "static/media/cytiva.9864df6f.png";